/**
 * 验证方法
 */
const regErrorStr = /^[^'"#%&<>]*$/
const regJSON = /^\{.*\}$/
const regRequired = /[^\s|.]/
const regEmail = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/
const regEmailCode = /^\S{6}$/
const regPassword = /^\S{6,16}$/
const regMobile = /^1[1-9]\d{9}$/
const regSpecialMobile = /^\d{5,11}$/
const regImgCaptcha = /^\S{4}$/
const regNumber = /^\d+$/

/**
 * 公共验证方法
 * @param  {Any}      value     被验证的值
 * @param  {RegExp}   reg       验证正则
  * @param {String}   message   提示文案
  * @return {Object}             验证结果 {valid: Boolean, message: String}
  */
export function testValue (value, reg, message) {
  return {
    valid: reg.test(value),
    message
  }
}

export default {
  /**
   * 验证字符串是否包含非法字符串 &<>
   * @param {String}  value       被验证的值
   */
  errorStr (value = '') {
    return testValue((value + ''), regErrorStr, '包含非法字符')
  },
  /**
   * 验证字符串是否为空
   * @param {String}  value       被验证的值
   */
  required (value = '') {
    return testValue((value + ''), regRequired, '必填')
  },
  /**
   * 验证字符串是否为JSON
   * @param {String}  value       被验证的值
   */
  json (value = '') {
    let res = testValue((value + ''), regJSON, 'JSON 格式错误')

    try {
      JSON.parse(value)
    } catch (e) {
      res.valid = false
    }

    return res
  },
  /**
   * 验证字符串是否为邮箱
   * @param {String}  value       被验证的值
   */
  email (value = '') {
    return testValue((value + ''), regEmail, '邮箱格式错误')
  },
  /**
  * 邮箱验证码 6 位字符
  * @param {String}  value       被验证的值
  */
  emailCode (value = '') {
    return testValue((value + ''), regEmailCode, '验证码格式错误')
  },
  /**
  * 验证密码格式 6-16 位字符
  * @param {String}  value       被验证的值
  */
  password (value = '') {
    return testValue((value + ''), regPassword, '请输入 6-16 位的密码')
  },
  /**
  * 验证密图形验证码 4 位字符
  * @param {String}  value       被验证的值
  */
  imgCaptcha (value = '') {
    return testValue((value + ''), regImgCaptcha, '验证码格式错误')
  },
  /**
   * 验证字符串是否为手机号
   * @param {String}  value       被验证的值
   */
  mobile (value = '') {
    return testValue((value + ''), regMobile, '手机号格式错误')
  },
  /**
   * 验证字符串是否为海外手机号
   * @param {String}  value       被验证的值
   */
  specialMobile (value = '') {
    return testValue((value + ''), regSpecialMobile, '手机号格式错误')
  },
  /**
   * 验证字符串是否为纯数字
   * @param {String}  value       被验证的值
   */
  number (value = '') {
    return testValue((value + ''), regNumber, '只能是数字')
  }
}
